import sharedFilters from './shared';

export default {
  pageFilters: [
    {
      id: 'title',
      label: 'Content',
      filters: {
        title: {
          boolean: 'OR',
          booleanSeparator: 'OR',
          value: null
        },
        contentType: null,
        network: null,
        studio: null,
        genre: null,
        runtime: null,
        first_release_date: null,
        airing_status: sharedFilters.airing_status,
        originating_country: sharedFilters.originating_country,
        originating_language: sharedFilters.originating_language
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: sharedFilters.sampleBalance,
        age: null,
        gender: null
      }
    },
    {
      id: 'firstReleaseDate',
      label: 'Date',
      filters: {
        date: null
      }
    },
    {
      id: 'metric',
      label: 'Metric',
      filters: {
        metric: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],
  queries: {
    affinityOR: {
      fields: [
        'title',
        'date',
        'country',
        'panel',
        'gender',
        'genre',
        'network',
        'studio',
        'metric',
        'airing_status',
        'first_release_date',
        'originating_country',
        'originating_language',
        'contentType',
        'age'
      ]
    },
    affinityAND: {
      fields: [
        'title',
        'date',
        'country',
        'panel',
        'gender',
        'genre',
        'network',
        'studio',
        'metric',
        'airing_status',
        'first_release_date',
        'originating_country',
        'originating_language',
        'contentType',
        'age'
      ]
    },
    titleCountryIndex: {
      fields: ['title', 'date', 'age', 'gender', 'affinityType', 'countryDemo']
    },
    titleAgeIndex: {
      fields: [
        'title',
        'date',
        'country',
        'panel',
        'gender',
        'affinityType',
        'ageDemo'
      ]
    },
    titleGenderIndex: {
      fields: [
        'title',
        'date',
        'country',
        'panel',
        'age',
        'affinityType',
        'genderDemo'
      ]
    }
  }
};
